<template lang="pug">
    #provider-purchase-invoice-list
        r-table(
            loading-text="Cargando facturas..."
            no-data-text="Sin facturas."
            no-remove
            no-search
            ref="table"
            v-bind="tableProps"
            @detail='submitDialog'
        )
        r-dialog(
            no-confirm
            v-bind='dialogProps'
            v-model='dialog'
        )
            r-form(
                v-bind='formProps'
                v-model='selected'
            )
</template>

<script>
    //
    import { RDialog, RForm, RTable } from '@/components/reusable_components/next'
    import ProviderPurchaseInvoiceHeader from '../table/ProviderPurchaseInvoiceHeader'
    import PurchaseInvoiceModel from '@/models/Purchase/PchPurchaseInvoice'
    //
    import PurchaseInvoiceFields from '@/views/Purchase/PchPurchaseInvoice/PchPurchaseInvoiceFields'
    import PurchaseInvoiceHeaders from '@/views/Purchase/PchPurchaseInvoice/PchPurchaseInvoiceHeaders'
    //
    export default {
        name: 'provider-purchase-invoice-list',
        components: {
            RDialog,
            RForm,
            RTable,
        },
        computed: {

            dialogProps() {
                return {
                    title: `Detalle de factura de compra #${this.selected.id}`
                }
            },

            /**
             * { function_description }
             *
             * @return     {Object}  { description_of_the_return_value }
             */
            formProps() {
                return {
                    editable: false,
                    fields: PurchaseInvoiceFields(this.arrProviderBranch),
                }
            },

            /**
             * { function_description }
             *
             * @return     {<type>}  { description_of_the_return_value }
             */
            providerId() {
                return this.$route.params.id
            },

            /**
             * { function_description }
             *
             * @return     {Object}  { description_of_the_return_value }
             */
            tableProps() {
                return {
                    service: PurchaseInvoiceModel,
                    paramFilter: {
                        pch_provider_id: this.providerId,
                    },
                    headers: PurchaseInvoiceHeaders,
                    filters: this.filters,
                }
            },
        },
        data() {
            return {
                dialog: false,
                filters: [
                    {
                        name: 'invoice_number',
                        props: {
                            label: 'Número folio',
                        },
                        flex: {
                            sm6: true,
                            lg5: true,
                        },
                        type: 'text-field',
                    },
                ],
                selected: {},
                arrProviderBranch:[],
            }
        },
        methods: {

            /**
             * Fetches a selected detail.
             */
            fetchSelectedDetail() {
                this.selected.reset()
            },

            /**
             * { function_description }
             *
             * @param      {<type>}  event   The event
             */
            submitClose(event) {
                this.dialog = false
            },

            /**
             * { function_description }
             *
             * @param      {<type>}  event   The event
             */
            submitDialog(event) {
                this.dialog = true
                this.selected = event.item.reset()
                 this.arrProviderBranch = [event.item.pch_provider_branch_offices]
            }
        }
    }
</script>
